import React, { useEffect, useState } from "react";
import { Option } from "react-multi-select-component";
import { toast } from "react-toastify";
import ImageUpload from "src/Components/GlobalComponents/ImageUplaod";
import PrimaryBtn from "src/Components/GlobalComponents/primaryBtn";
import SelectDropdown from "src/Components/GlobalComponents/SelectDropdown";
import CustomWebsiteDropdown from "src/Components/GlobalComponents/Widget/CustomWebsiteDropdown";
import SimpleInput from "src/Components/SimpleInput";
import httpRequest from "src/helpers/httpRequest";
import { IChildCategory } from "src/types/GlobalInterfaces";

interface IProps {
  getLoader: boolean;
  onSuccess: () => void;
  isEdit: IChildCategory | null;
  allMainCategory: { value: string; label: string }[];
}

interface IObjInterface {
  mainCategoryId: string;
  subCategoryId: string;
  categoryBanner: File | null | string;
  childCategoryImage: File | null | string;
  childCategoryName: string;
  description: string;
}

const UpsertChildCategory: React.FC<IProps> = ({
  getLoader = false,
  onSuccess = () => {},
  isEdit = null,
  allMainCategory = [],
}) => {
  // sub category states
  const [subLoader, setSubLoader] = useState<boolean>(false);
  const [allSubCategories, setAllSubCategories] = useState<
    { value: string; label: string }[]
  >([]);
  // sub category states

  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [payload, setPayload] = useState<IObjInterface>({
    mainCategoryId: "",
    subCategoryId: "",
    categoryBanner: null,
    childCategoryImage: null,
    childCategoryName: "",
    description: "",
  });

  const handleSubmit = async () => {
    const {
      mainCategoryId,
      subCategoryId,
      categoryBanner,
      childCategoryImage,
      childCategoryName,
      description,
    } = payload;
    if (!categoryBanner) {
      toast("Please upload a banner image.", { type: "error" });
    } else if (!childCategoryImage) {
      toast("Please upload a category image.", { type: "error" });
    } else if (!mainCategoryId) {
      toast("Please select a main category.", { type: "error" });
    } else if (!subCategoryId) {
      toast("Please select a sub category.", { type: "error" });
    } else if (!childCategoryName) {
      toast("Please enter the category name.", { type: "error" });
    } else {
      setIsLoader(true);
      const formData = new FormData();
      formData.append("mainCategoryId", mainCategoryId);
      formData.append("subCategoryId", subCategoryId);
      formData.append("categoryBanner", categoryBanner);
      formData.append("childCategoryImage", childCategoryImage);
      formData.append("childCategoryName", childCategoryName);
      formData.append("description", description);
      const path = isEdit
        ? `/child-category/edit/${isEdit._id}`
        : "/child-category/create";

      const { res, err } = await httpRequest<any>({
        method: isEdit ? "put" : "post",
        path,
        params: formData,
        header: { "Content-Type": "multipart/form-data" },
      });
      if (res) {
        toast(`Child category ${isEdit ? "updated" : "added"} successfully.`, {
          type: "success",
        });
        onSuccess();
      } else {
        toast(err, { type: "error" });
      }
      setIsLoader(false);
    }
  };

  const fetchAllSubCategories = async () => {
    setSubLoader(true);
    const { res, err } = await httpRequest<
      { _id: string; subCategoryName: string }[]
    >({ path: `/sub-category/getSubMyMainId/${payload?.mainCategoryId}` });
    if (res) {
      const arr =
        res?.map((v) => ({ value: v?._id, label: v?.subCategoryName })) || [];
      setAllSubCategories(arr);
    } else {
      toast(err, { type: "error" });
    }
    setSubLoader(false);
  };

  useEffect(() => {
    if (payload?.mainCategoryId) {
      fetchAllSubCategories();
    }
  }, [payload?.mainCategoryId]);

  useEffect(() => {
    if (isEdit && typeof isEdit !== null) {
      let {
        mainCategoryId = "",
        subCategoryId = "",
        categoryBanner = "",
        childCategoryImage = "",
        childCategoryName = "",
        description = "",
      } = isEdit;
      setPayload({
        mainCategoryId,
        subCategoryId,
        categoryBanner,
        childCategoryImage,
        childCategoryName,
        description,
      });
    }
  }, [isEdit]);
  return (
    <div className="table-container">
      <div className="admin-create-role-main">
        <div className="admin-create-role">
          <div className="create-operators-res">
            <div>
              <h3 className="font-size-18px text-[#2F2F31] mb-1 font-Poppins-Regular">
                <span className="text-[#FF0000]">* </span> Child Banner Image
              </h3>
              <ImageUpload
                image={payload?.categoryBanner}
                onImageChange={(file: File | null) =>
                  setPayload((prev) => ({ ...prev, categoryBanner: file }))
                }
                extraClasses={"w-full"}
                labelId="child-banner-input"
              />
            </div>
            <div>
              <h3 className="font-size-18px text-[#2F2F31] mb-1 font-Poppins-Regular">
                <span className="text-[#FF0000]">* </span> Child Categories Image
              </h3>
              <ImageUpload
                image={payload?.childCategoryImage}
                onImageChange={(file: File | null) =>
                  setPayload((prev) => ({ ...prev, childCategoryImage: file }))
                }
                labelId="child-category-image-input"
              />
            </div>
            {/* <SelectDropdown
              loader={getLoader}
              options={allMainCategory}
              isMulti={true}
              data={allMainCategory.filter(
                (v) => v?.value === payload?.mainCategoryId
              )}
              setData={(e) => {
                setPayload((prev) => ({ ...prev, subCategoryId: "" }));
                setPayload((prev) => ({
                  ...prev,
                  mainCategoryId: e[0]?.value || "",
                }));
              }}
              checkboxShow={true}
              isLabel={true}
              labelText="Category Name"
              isRequired={true}
            /> */}
            <CustomWebsiteDropdown
              options={allMainCategory}
              data={allMainCategory.filter(
                (v) => v?.value === payload?.mainCategoryId
              )}
              loading={getLoader}
              setData={(e) =>
                setPayload((prev) => ({
                  ...prev,
                  mainCategoryId: e[0]?.value || "",
                }))
              }
              labelText="Main Category Name"
              isRequired={true}
              dropdownMainId="main-category-dropdown"
              clearId="main-cat"
              optionId={(v: Option, index) =>
                `main-category-option-${index + 1}`
              }
            />
            <CustomWebsiteDropdown
              options={allSubCategories}
              data={allSubCategories.filter(
                (v) => v?.value === payload?.subCategoryId
              )}
              loading={subLoader}
              setData={(e) =>
                setPayload((prev) => ({
                  ...prev,
                  subCategoryId: e[0]?.value || "",
                }))
              }
              labelText="Sub Category Name"
              dropdownMainId="sub-category-dropdown"
              clearId="sub-cat"
              optionId={(v: Option, index) =>
                `sub-category-option-${index + 1}`
              }
              isRequired={true}
            />
            {/* <SelectDropdown
              loader={subLoader}
              options={allSubCategories}
              isMulti={false}
              data={allSubCategories.filter(
                (v) => v?.value === payload?.subCategoryId
              )}
              setData={(e) =>
                setPayload((prev) => ({
                  ...prev,
                  subCategoryId: e[0]?.value || "",
                }))
              }
              checkboxShow={false}
              isLabel={true}
              labelText="Sub Category Name"
              isRequired={true}
            /> */}
            <SimpleInput
              value={payload?.childCategoryName}
              onChange={(val: string) => {
                let filteredValue = val.replace(/[^a-zA-Z0-9\s]/g, "");
                setPayload((prev) => ({
                  ...prev,
                  childCategoryName: filteredValue,
                }));
              }}
              isLabel={true}
              labelText="Category Name"
              isRequired={true}
              id="child-category-name-input"
              maxLength={40}
            />
            <SimpleInput
              value={payload?.description}
              onChange={(val: string) =>
                setPayload((prev) => ({ ...prev, description: val }))
              }
              isLabel={true}
              labelText="Description"
              type="textArea"
              isLimit={500}
              rows={5}
              id="description-input"
              maxLength={500}
              isRequired={true}
            />
          </div>
        </div>
        <div className="flex justify-end my-6">
          <PrimaryBtn
            loader={isLoader}
            ButtonText="Save"
            btnExtraStyle={{
              backgroundColor: "#00443f",
              borderRadius: "1.5rem",
            }}
            onPress={handleSubmit}
            id="save-child-category-btn"
          />
        </div>
      </div>
    </div>
  );
};

export default UpsertChildCategory;
